import { useState } from 'react'

export const getLocalStorage = (key: string) => {
  if (typeof window === 'undefined') return null

  return localStorage.getItem(key)
}

export const setLocalStorage = (key: string, value: string) => {
  if (typeof window === 'undefined') return null

  return localStorage.setItem(key, value)
}

export interface IUser {
  location: string | null
  locale: string | null
  isAdult: boolean | null
  remember: boolean | null
  wasPromptedToday: boolean
  complete: boolean
  setLocation: (a: string) => void
  setLocale: (a: string) => void
  setIsAdult: (a: boolean) => void
  setRemember: (a: boolean) => void
}

export const useUser = () => {
  const [remember, _setRemember] = useState(true)
  const [location, _setLocation] = useState(getLocalStorage('location'))

  const [isAdult, _setIsAdult] = useState(
    getLocalStorage('is-adult') == null
      ? null
      : getLocalStorage('is-adult') === '1',
  )

  const wasPromptedToday =
    getLocalStorage('last-prompt') === new Date().toISOString().split('T')[0]

  const complete = !!(location != null && isAdult) || wasPromptedToday

  const setLocation = (location: string) => {
    if (remember) setLocalStorage('location', location)
    _setLocation(location)
  }

  const setIsAdult = (isAdult: boolean) => {
    if (remember) setLocalStorage('is-adult', isAdult ? '1' : '0')
    _setIsAdult(isAdult)
  }

  const setRemember = (remember: boolean) => {
    if (!remember) localStorage.clear()
    _setRemember(remember)
  }

  return {
    remember,
    location,
    isAdult,
    setLocation,
    setIsAdult,
    setRemember,
    complete,
    wasPromptedToday,
  } as IUser
}
